import * as Yup from "yup";
let validationSchema = Yup.object({
  email: Yup.string("Email is Required")
    .email("Email Must be Unique")
    .required("Email is Required"),
  password: Yup.string("Password is Required").required("Password is Required"),
});

export default validationSchema;
